<template>
    <div class="additional-prices-filter">
      <div v-show="priceTableLoader" class="price-table-loader">
        <base-loader size="50" weight="3"/>
      </div>
      <div v-show="!priceTableLoader" class="additional-prices-controlers">
        <span class="bold-text" v-if="!showTourFromFilter">{{localizeList.minimalPriceUpper}}</span>
        <div class="flex" v-else>
          <span class="bold-text">{{localizeList.departFrom}}:</span>
          <div v-for="(item, key) in citiesFrom"
                :key="key"
                v-show="!item.label[1] || !item.label[1].includes('Infinity')"
                @click="changeCitiFrom(item.value)"
                :class="['from-btn',{'active': cityFromStatus === item.value}]">
            <span v-if="item.value === -2">{{localizeList.all}}</span>
            <span v-else>
                {{correctCityLabel(item.label)}}
            </span>
          </div>
        </div>
        <span class="bold-text ml-2">{{localizeList.departTo}}:</span>
        <button-select v-model="cityToStatusData"
                        @change="setPriceFromTableCities(true, true)"
                        :items="citiesTo"/>
      </div>
      <div class="price-table">
        <div class="thead" ref="priceTableHead">
          <div class="td slider">
            <div @click="addintionalPriceSlideLeft()" class="slide slide-left">
              <icon name="angle" width="14px" height="14px" fill="var(--lighten-5-color)"/>

            </div>
            <div @click="addintionalPriceSlideRight()" class="slide slide-right">
              <icon name="angle" width="14px" height="14px" fill="var(--lighten-5-color)"/>

            </div>
          </div>
          <div v-for="(item, key) in addintionalPriceHeader"
               :key="key"
               class="td">
            <div>{{correctDate(item)}}</div>
          </div>
        </div>
        <div class="tbady" ref="priceTableBody">
          <div v-for="(item, key) in highlightedPriceItems"
               :key="key"
               ref="priceTableRow"
               class="td-row"
               >
            <div v-for="(item2, key2) in item"
                 :key="`${key}-${key2}`"
                 @click="setAddintionalPrice(key, key2, item2)"
                 :class="['td',{'td-left': key2 === 0},
                 {'active': checkIsActive(key, key2, item2.value)},
                 {'disabled': item2.isEmpty}, 
                 {'is-min-price': item2.isMinPrice }]">
              <span v-if="key2 === 0">
                  {{correctDuration(item2.text) + " " + localizeList[correctDayWord(item2.text)]}}
              </span>
              <span v-else-if="!item2.isEmpty">
                  {{localizeList.fromPrice + " " + correctPrice(item2.text) + " " +getCurrencyDisplayBySettings(rate)}}
              </span>
              <span v-else>
                  {{item2.text}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import moment from "moment";
    import buttonSelect from "../buttonSelect";

    export default {
        name: "priceTable",
        components: {
            buttonSelect
        },
        props: {
            citiesFrom: {
                type: Array,
                default: () => []
            },
            citiesTo: {
                type: Array,
                default: () => []
            },
            addintionalPriceHeader: {
                type: Array,
                default: () => []
            },
            addintionalPriceItems: {
                type: Array,
                default: () => []
            },
            addintionalPriceHeaderAll: {
                type: Array,
                default: () => []
            },
            addintionalPriceItemsAll: {
                type: Array,
                default: () => []
            },
            addintionalPrice: {
                type: Array,
                default: () => []
            },
            rate: {
                type: Object,
                default: null
            },
            tourSettings: {
                type: Object,
                default: null
            },
            cityFromStatus: {
                type: Number,
                default: -2
            },
            cityToStatus: {
                type: Number,
                default: -1
            },
            createPriceTableColumnsEmitter: {
                type: Number,
                default: 0
            },
            sliderPosition: {
                type: Number,
                default: 0
            },
            priceTableLoader: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                cityToStatusData: this.cityToStatus
            }
        },
        computed: {
            highlightedPriceItems(){
              const result = this.addintionalPriceItems.map(el => {
                  const min = Math.min(...el.filter(el => parseInt(el.value) >= 0).map(item => item.value))
                  const prices = []
                  return el.map(item => {
                    if (item.value === min && !prices.length) {
                      prices.push(item)
                      return {...item, isMinPrice: true}
                    }
                    return item
                  })
              })

              return result
            },
            showTourFromFilter() {
                return window.settings.showTourFromFilter || window.settings.showTourFromFilter === undefined
            },
            dayMode() {
                let res = ["day", "day2", "days"];
                if (this.tourSettings && (this.tourSettings.TourSearchMode === 1 || this.tourSettings.TourSearchMode === 2)) {
                    res = ["night", "night2", "nights"]
                }
                return res
            }
        },
        mounted() {
            this.checkPriceTableScroll();
            this.scrollToActiveItem();
        },
        methods: {
            scrollToActiveItem() {
                const top = this.addintionalPrice[0] - 4;
                const left = this.addintionalPrice[1] - 4;

                if (top > 0) {
                    this.$refs.priceTableBody.scrollTo({top: top * 47})
                }
                if (left > 0) {
                    let i = 0;
                    while (i <= left) {
                        this.addintionalPriceSlideRight();
                        i++
                    }
                }
            },
            checkPriceTableScroll() {
                const scrollHeight = this.$refs.priceTableBody.scrollHeight;
                const clientHeight = this.$refs.priceTableBody.clientHeight;
                const hasScroll = scrollHeight > clientHeight;

                this.$refs.priceTableHead.style.paddingRight = hasScroll ? "16px" : "";
            },
            changeCitiFrom(value) {
                this.$emit("changeCitiFrom", value)
            },
            setPriceFromTableCities(sendRequest = false, clientEvent = false) {
                this.$nextTick(() => {
                    this.$emit("setPriceFromTableCities", [sendRequest, clientEvent]);
                    this.$emit("changeCityToStatus", this.cityToStatusData);
                })
            },
            setAddintionalPrice() {
                this.$emit("setAddintionalPrice", arguments)
            },
            checkIsActive(key1, key2, value) {
                let index = this.sliderPosition;
                return this.addintionalPrice[0] === key1 && this.addintionalPrice[1] === key2 + index && this.addintionalPrice[2] === value
            },
            addintionalPriceSlideLeft() {
                this.$emit("addintionalPriceSlideLeft")
            },
            addintionalPriceSlideRight() {
                this.$emit("addintionalPriceSlideRight")
            },
            correctCityLabel(label) {
                let first = label[0];
                let rate = label[2].split(" ")[1];
                let price = label[2].split(" ")[0];
                let second = this.localizeList[label[1]] + " " + this.correctPrice(price) + " " + rate;
                return first +", "+ second
            },
            correctDuration(n) {
                return n === 0 ? "<1" : n
            },
            correctDayWord(day) {
                if (day == 1) {
                    return this.dayMode[0]
                } else if (day < 5) {
                    return this.dayMode[1]
                } else {
                    return this.dayMode[2]
                }
            },
            correctDate(item) {
                return moment(new Date(item.split("T")[0])).format("DD MMM")
            },
            getCurrencyDisplayBySettings(rate){
                if (!rate) return;

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            }
        },
        watch: {
            cityToStatus(val) {
                this.cityToStatusData = val;
            },
            addintionalPriceItems() {
                this.checkPriceTableScroll();
            },
            addintionalPrice() {
                this.scrollToActiveItem()
            },
            addintionalPriceItemsAll() {
                this.scrollToActiveItem()
            },
            createPriceTableColumnsEmitter() {
                if (!this.$refs.priceTableHead || !this.$refs.priceTableRow) {
                    return
                }
                const columnCount = this.addintionalPriceHeaderAll.length > 5 ? 5 : this.addintionalPriceHeaderAll.length;
                this.$refs.priceTableHead.style.gridTemplateColumns = `99px repeat(${columnCount}, 1fr)`;
                this.$refs.priceTableRow = this.$refs.priceTableRow.map(x => {
                    x.style.gridTemplateColumns = `99px repeat(${columnCount}, 1fr)`;
                    return x
                });
            }
        }
    }
</script>

<style scoped>
    .price-table-loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

    .additional-prices-controlers {
        display: flex;
        align-items: center;
        margin-bottom: 19px;
        white-space: nowrap;
    }

    .additional-prices-controlers .bold-text {
        font-weight: bold;
        font-size: 15px;
        line-height: 29px;
        color: var(--dark-1-color);
        margin-right: 8px;
    }

    .additional-prices-controlers .bold-text.ml-2 {
        margin-left: 12px;
    }

    .additional-prices-controlers .from-btn {
        background: var(--primary-2-color);
        border: 1px solid #B2DBF8;
        box-sizing: border-box;
        border-radius: 3px;
        padding: 9px 12px;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: var(--primary-color);
        transition: all .2s;
        cursor: pointer;
        margin-right: 8px;
    }

    .additional-prices-controlers .from-btn.active {
        background: var(--primary-color);
        color: var(--white-color);
    }

    .additional-prices-controlers .button-select {
        width: auto;
        min-width: 160px;
    }

    .price-table .thead {
        display: grid;
        grid-template-columns: 99px repeat(5, 1fr);
        background-color: var(--primary-2-color);
        border: 1px solid var(--lighten-4-color);
    }

    .price-table .thead .td.slider {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        min-width: 99px;
        flex: 0;
    }

    .price-table .thead .slider .slide {
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--white-color);
        border-radius: 50%;
        cursor: pointer;
        transition: all .2s;
    }

    .price-table .thead .slider .slide:hover {
        background-color: #fafafa
    }

    .price-table .thead .slider .slide-left {
        transform: rotate(90deg)
    }
    .price-table .thead .slider .slide-right {
        margin-left: 12px;
        transform: rotate(-90deg)
    }

    .price-table .tbady {
        max-height: 237px;
        overflow: auto;
    }

    .price-table .thead .td,
    .price-table .tbady .td {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 15px;
        line-height: 29px;
        color: var(--dark-1-color);
    }
    .price-table .tbady .td {
        border: 1px solid var(--lighten-4-color);
        border-right: none;
    }
    .price-table .thead .td {
        border-right: 1px solid var(--lighten-4-color);
    }

    .price-table .thead .td:last-child {
        border-right: none;
    }

    .price-table .tbady .td-row {
        display: grid;
        grid-template-columns: 99px repeat(5, 1fr);
    }

    .price-table .tbady .td {
        padding: 14px 0;
        text-align: center;
        border-top: none;
        line-height: 19px;
        color: var(--primary-color);
    }

    .price-table .tbady .td-row .td:not(:first-child) {
        cursor: pointer;
        transition: all .1s;
    }

    .price-table .tbady .td-row .td:not(:first-child):hover {
        background-color: #fafafa;
    }

    .price-table .tbady .td-row .disabled.td:hover {
        background-color: unset;
        cursor: default;
    }

    .price-table .tbady .td:last-child {
        border-right: 1px solid var(--lighten-4-color);
    }

    .price-table .tbady .td-left {
        padding: 14px 20px;
        text-align: left;
        color: var(--dark-1-color);
    }

    .price-table .tbady .td-left span {
        white-space: nowrap;
    }

    .price-table .tbady .td-row .td:not(:first-child).active {
        background-color: var(--primary-color);
        color: var(--white-color)
    }

    .price-table .tbady .td-row .is-min-price {
      background-color: #fdf9c9;
    }

</style>